module.exports = __webpack_public_path__ + "img/comment3.599cfde2.png";